(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-variant-grid"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Filter nav ---------- */
  document.querySelectorAll('[data-filter-nav]').forEach(function (nav) {
    var sectionId = nav.getAttribute('data-filter-nav');
    var grid = document.querySelector('[data-grid="' + sectionId + '"]');
    if (!grid) return;

    var cards = grid.querySelectorAll('.color-variant-card');
    var boxes = nav.querySelectorAll('.color-variant-filter-box');

    nav.addEventListener('click', function (event) {
      var box = event.target.closest('.color-variant-filter-box');
      if (!box) return;

      boxes.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      box.classList.add('is-active');
      box.setAttribute('aria-pressed', 'true');

      var value = box.getAttribute('data-filter-value');

      cards.forEach(function (card) {
        if (value === 'all') {
          card.classList.remove('is-hidden-by-filter');
          return;
        }
        var tags = (card.getAttribute('data-tags') || '').split('|');
        if (tags.indexOf(value) !== -1) {
          card.classList.remove('is-hidden-by-filter');
        } else {
          card.classList.add('is-hidden-by-filter');
        }
      });
    });
  });

  /* ---------- Swipe dots: keep the active dot in sync with the image showing ---------- */
  (function () {
    if (window.__colorVariantDotsBound) return;
    window.__colorVariantDotsBound = true;

    document.addEventListener('scroll', function (e) {
      var track = e.target;
      if (!track.classList || !track.classList.contains('color-variant-card__track')) return;
      if (track.__cvRaf) return;

      track.__cvRaf = requestAnimationFrame(function () {
        track.__cvRaf = null;
        var card = track.closest('.color-variant-card');
        if (!card || !track.clientWidth) return;
        var index = Math.round(track.scrollLeft / track.clientWidth);
        card.querySelectorAll('.color-variant-card__dot').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      });
    }, { capture: true, passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-week-strip"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-filter-nav]').forEach(function (nav) {
    var sectionId = nav.getAttribute('data-filter-nav');
    var track = document.querySelector('[data-track="' + sectionId + '"]');
    if (!track) return;

    var cards = track.querySelectorAll('.launch-strip-card');
    var boxes = nav.querySelectorAll('.launch-strip-filter-box');

    nav.addEventListener('click', function (event) {
      var box = event.target.closest('.launch-strip-filter-box');
      if (!box) return;

      boxes.forEach(function (b) {
        b.classList.remove('is-active');
      });
      box.classList.add('is-active');

      var value = box.getAttribute('data-filter-value');

      cards.forEach(function (card) {
        if (value === 'all') {
          card.classList.remove('is-hidden-by-filter');
          return;
        }
        var tags = (card.getAttribute('data-tags') || '').split('|');
        if (tags.indexOf(value) !== -1) {
          card.classList.remove('is-hidden-by-filter');
        } else {
          card.classList.add('is-hidden-by-filter');
        }
      });
    });
  });

  document.querySelectorAll('[data-arrow]').forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      var sectionId = arrow.getAttribute('data-track-id');
      var track = document.querySelector('[data-track="' + sectionId + '"]');
      if (!track) return;

      var card = track.querySelector('.launch-strip-card:not(.is-hidden-by-filter)');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var scrollAmount = card ? card.getBoundingClientRect().width + gap : 240;
      var direction = arrow.getAttribute('data-arrow') === 'next' ? 1 : -1;

      track.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
